import React from 'react';

import { Banner, Text } from '@betterment/samba-react';

export const InfoBanner: React.FC = () => {
  return (
    <Banner variant="info">
      <Banner.Content>
        <Text>
          Proceeds will be used to rebalance your client’s portfolio, bringing it closer to target. If you're looking to
          generate cash, exit this flow and make a withdrawal to a linked bank account or transfer to Cash Reserve.
        </Text>
      </Banner.Content>
    </Banner>
  );
};
